import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_active_table = _resolveComponent("active-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.title)
    }, " Шаблоны парсинга ", 2),
    _createVNode(_component_active_table, {
      page: _ctx.page,
      "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
      state: "secondary",
      "table-key": "templates",
      "key-field": _ctx.keyField,
      columns: _ctx.columns,
      records: _ctx.records,
      actions: _ctx.actions,
      limit: _ctx.limit,
      total: _ctx.total
    }, null, 8, ["page", "key-field", "columns", "records", "actions", "limit", "total"])
  ], 2))
}